// Environmental Construction Materials Database
// For erosion control, stormwater management, remediation, and green building

// EROSION CONTROL MATERIALS
export const erosionControlDatabase = [
  // === SILT FENCE ===
  {
    name: 'Standard Silt Fence (36")',
    category: 'Silt Fence',
    costPerLinearFt: 3.50,
    description: 'Standard 36-inch woven geotextile silt fence'
  },
  {
    name: 'Heavy Duty Silt Fence (48")',
    category: 'Silt Fence',
    costPerLinearFt: 5.25,
    description: '48-inch reinforced silt fence for steep slopes'
  },
  {
    name: 'Wire-Backed Silt Fence',
    category: 'Silt Fence',
    costPerLinearFt: 6.50,
    description: 'Wire mesh reinforced for high flow areas'
  },
  {
    name: 'Super Silt Fence (Double)',
    category: 'Silt Fence',
    costPerLinearFt: 8.75,
    description: 'Double layer for maximum sediment control'
  },
  // === EROSION BLANKETS ===
  {
    name: 'Straw Erosion Blanket (Single Net)',
    category: 'Erosion Blankets',
    costPerSquareFt: 0.14,
    lifespan: '12 months',
    description: 'Biodegradable straw blanket for slopes < 3:1'
  },
  {
    name: 'Straw/Coconut Blanket (Double Net)',
    category: 'Erosion Blankets',
    costPerSquareFt: 0.24,
    lifespan: '24 months',
    description: 'Straw-coconut blend for slopes 2:1 to 3:1'
  },
  {
    name: 'Coconut Fiber Blanket',
    category: 'Erosion Blankets',
    costPerSquareFt: 0.32,
    lifespan: '36 months',
    description: '100% coconut for steep slopes and channels'
  },
  {
    name: 'Excelsior (Wood Fiber) Blanket',
    category: 'Erosion Blankets',
    costPerSquareFt: 0.19,
    lifespan: '18 months',
    description: 'Curled wood excelsior for general use'
  },
  {
    name: 'Turf Reinforcement Mat (TRM)',
    category: 'Erosion Blankets',
    costPerSquareFt: 0.50,
    lifespan: 'Permanent',
    description: 'Permanent synthetic mat for high flow channels'
  },
  {
    name: 'High Performance TRM (HPTRM)',
    category: 'Erosion Blankets',
    costPerSquareFt: 0.81,
    lifespan: 'Permanent',
    description: 'Heavy duty permanent channel lining'
  },
  // === HYDROSEEDING ===
  {
    name: 'Standard Hydroseed',
    category: 'Hydroseeding',
    costPerSquareFt: 0.05,
    description: 'Seed, fertilizer, tackifier mix'
  },
  {
    name: 'Bonded Fiber Matrix (BFM)',
    category: 'Hydroseeding',
    costPerSquareFt: 0.13,
    description: 'Hydraulic erosion control product'
  },
  {
    name: 'Flexible Growth Medium (FGM)',
    category: 'Hydroseeding',
    costPerSquareFt: 0.21,
    description: 'Premium hydraulic mulch system'
  },
  // === CHECK DAMS ===
  {
    name: 'Rock Check Dam (Small)',
    category: 'Check Dams',
    costPerEach: 350,
    description: 'Rock check dam up to 18" high'
  },
  {
    name: 'Rock Check Dam (Large)',
    category: 'Check Dams',
    costPerEach: 750,
    description: 'Rock check dam 18-36" high'
  },
  {
    name: 'Straw Bale Check Dam',
    category: 'Check Dams',
    costPerEach: 125,
    description: 'Temporary straw bale check dam'
  },
  {
    name: 'Log Check Dam',
    category: 'Check Dams',
    costPerEach: 285,
    description: 'Staked log check dam'
  },
  {
    name: 'Fiber Roll (Wattle)',
    category: 'Check Dams',
    costPerLinearFt: 4.50,
    description: 'Fiber roll for slope and check dam use'
  },
  // === INLET PROTECTION ===
  {
    name: 'Inlet Protection (Fabric)',
    category: 'Inlet Protection',
    costPerEach: 125,
    description: 'Geotextile fabric inlet protection'
  },
  {
    name: 'Inlet Protection (Block & Gravel)',
    category: 'Inlet Protection',
    costPerEach: 225,
    description: 'Concrete block and gravel inlet protection'
  },
  {
    name: 'Inlet Filter Bag',
    category: 'Inlet Protection',
    costPerEach: 85,
    description: 'Dewatering filter bag for inlet'
  },
  {
    name: 'Sediment Trap (Small)',
    category: 'Inlet Protection',
    costPerEach: 1500,
    description: 'Small sediment trap < 1 acre drainage'
  },
  {
    name: 'Sediment Trap (Large)',
    category: 'Inlet Protection',
    costPerEach: 4500,
    description: 'Large sediment trap 1-5 acres drainage'
  }
];

// STORMWATER MANAGEMENT
export const stormwaterDatabase = [
  // === DETENTION/RETENTION ===
  {
    name: 'Detention Pond Excavation',
    category: 'Detention/Retention',
    costPerCubicYard: 8.50,
    description: 'Excavation for dry detention pond'
  },
  {
    name: 'Retention Pond (Wet) Excavation',
    category: 'Detention/Retention',
    costPerCubicYard: 12.50,
    description: 'Excavation for permanent wet pond'
  },
  {
    name: 'Pond Liner (HDPE 40mil)',
    category: 'Detention/Retention',
    costPerSquareFt: 1.25,
    description: 'HDPE geomembrane pond liner'
  },
  {
    name: 'Pond Liner (HDPE 60mil)',
    category: 'Detention/Retention',
    costPerSquareFt: 1.85,
    description: 'Heavy duty HDPE liner'
  },
  {
    name: 'Clay Liner (12")',
    category: 'Detention/Retention',
    costPerSquareFt: 0.85,
    description: 'Compacted clay liner'
  },
  {
    name: 'Riser Structure',
    category: 'Detention/Retention',
    costPerEach: 8500,
    description: 'Outlet control riser structure'
  },
  {
    name: 'Spillway (Concrete)',
    category: 'Detention/Retention',
    costPerLinearFt: 350,
    description: 'Concrete emergency spillway'
  },
  // === UNDERGROUND DETENTION ===
  {
    name: 'Underground Chamber (36")',
    category: 'Underground Detention',
    costPerLinearFt: 125,
    storagePerFt: 5.6,
    description: '36" arch chamber system'
  },
  {
    name: 'Underground Chamber (48")',
    category: 'Underground Detention',
    costPerLinearFt: 185,
    storagePerFt: 9.8,
    description: '48" arch chamber system'
  },
  {
    name: 'Concrete Box Detention',
    category: 'Underground Detention',
    costPerCubicFt: 18,
    description: 'Precast concrete underground detention'
  },
  {
    name: 'Large Diameter Pipe Storage',
    category: 'Underground Detention',
    costPerLinearFt: 250,
    description: 'Large diameter pipe for storage'
  },
  // === BIORETENTION ===
  {
    name: 'Bioretention Soil Mix',
    category: 'Bioretention',
    costPerCubicYard: 65,
    description: 'Engineered bioretention media'
  },
  {
    name: 'Bioretention Underdrain',
    category: 'Bioretention',
    costPerLinearFt: 18,
    description: '4" perforated underdrain pipe'
  },
  {
    name: 'Rain Garden Plants',
    category: 'Bioretention',
    costPerSquareFt: 8.50,
    description: 'Native plantings for bioretention'
  },
  // === PERMEABLE PAVEMENT ===
  {
    name: 'Permeable Concrete',
    category: 'Permeable Pavement',
    costPerSquareFt: 12,
    description: 'Pervious concrete pavement'
  },
  {
    name: 'Permeable Asphalt',
    category: 'Permeable Pavement',
    costPerSquareFt: 10,
    description: 'Porous asphalt pavement'
  },
  {
    name: 'Permeable Pavers',
    category: 'Permeable Pavement',
    costPerSquareFt: 18,
    description: 'Interlocking permeable pavers'
  },
  {
    name: 'Grass Pavers (Plastic Grid)',
    category: 'Permeable Pavement',
    costPerSquareFt: 6.50,
    description: 'Grass/gravel paver system'
  },
  // === GREEN INFRASTRUCTURE ===
  {
    name: 'Bioswale',
    category: 'Green Infrastructure',
    costPerLinearFt: 45,
    description: 'Vegetated drainage swale'
  },
  {
    name: 'Green Roof (Extensive)',
    category: 'Green Infrastructure',
    costPerSquareFt: 22,
    description: 'Low-profile vegetated roof'
  },
  {
    name: 'Green Roof (Intensive)',
    category: 'Green Infrastructure',
    costPerSquareFt: 45,
    description: 'Deep soil vegetated roof'
  },
  {
    name: 'Rain Barrel/Cistern',
    category: 'Green Infrastructure',
    costPerGallon: 1.25,
    description: 'Rainwater harvesting storage'
  },
  {
    name: 'Tree Box Filter',
    category: 'Green Infrastructure',
    costPerEach: 12500,
    description: 'Stormwater tree filter box'
  }
];

// REMEDIATION MATERIALS
export const remediationDatabase = [
  // === CONTAMINATED SOIL ===
  {
    name: 'Contaminated Soil Excavation',
    category: 'Soil Remediation',
    costPerCubicYard: 45,
    description: 'Excavate and stage contaminated soil'
  },
  {
    name: 'HAZMAT Soil Disposal (Non-Haz)',
    category: 'Soil Remediation',
    costPerTon: 85,
    description: 'Dispose petroleum-contaminated soil'
  },
  {
    name: 'HAZMAT Soil Disposal (Hazardous)',
    category: 'Soil Remediation',
    costPerTon: 350,
    description: 'Dispose hazardous contaminated soil'
  },
  {
    name: 'Soil Treatment (Bioremediation)',
    category: 'Soil Remediation',
    costPerCubicYard: 75,
    description: 'On-site bioremediation treatment'
  },
  {
    name: 'Soil Treatment (Chemical)',
    category: 'Soil Remediation',
    costPerCubicYard: 125,
    description: 'Chemical oxidation treatment'
  },
  {
    name: 'Clean Fill Import',
    category: 'Soil Remediation',
    costPerCubicYard: 22,
    description: 'Import certified clean fill'
  },
  // === GROUNDWATER ===
  {
    name: 'Monitoring Well (2")',
    category: 'Groundwater',
    costPerLinearFt: 45,
    description: '2" PVC monitoring well'
  },
  {
    name: 'Monitoring Well (4")',
    category: 'Groundwater',
    costPerLinearFt: 65,
    description: '4" PVC monitoring well'
  },
  {
    name: 'Recovery Well',
    category: 'Groundwater',
    costPerLinearFt: 125,
    description: 'Groundwater extraction well'
  },
  {
    name: 'Groundwater Treatment (GAC)',
    category: 'Groundwater',
    costPerThousandGallons: 8,
    description: 'Granular activated carbon treatment'
  },
  {
    name: 'Groundwater Treatment (Air Strip)',
    category: 'Groundwater',
    costPerThousandGallons: 5,
    description: 'Air stripping treatment'
  },
  // === TANKS ===
  {
    name: 'UST Removal (500-1000 gal)',
    category: 'Tank Removal',
    costPerEach: 4500,
    description: 'Remove underground storage tank'
  },
  {
    name: 'UST Removal (2000-5000 gal)',
    category: 'Tank Removal',
    costPerEach: 8500,
    description: 'Remove large underground tank'
  },
  {
    name: 'UST Removal (10000+ gal)',
    category: 'Tank Removal',
    costPerEach: 18500,
    description: 'Remove very large underground tank'
  },
  {
    name: 'AST Removal (per gallon capacity)',
    category: 'Tank Removal',
    costPerGallon: 0.85,
    description: 'Remove above-ground storage tank'
  },
  {
    name: 'Tank Cleaning/Decon',
    category: 'Tank Removal',
    costPerGallon: 0.35,
    description: 'Clean and decontaminate tank'
  },
  // === ASBESTOS/LEAD ===
  {
    name: 'Asbestos Abatement (Friable)',
    category: 'Hazmat Abatement',
    costPerSquareFt: 15,
    description: 'Remove friable asbestos materials'
  },
  {
    name: 'Asbestos Abatement (Non-Friable)',
    category: 'Hazmat Abatement',
    costPerSquareFt: 8,
    description: 'Remove non-friable asbestos'
  },
  {
    name: 'Lead Paint Abatement',
    category: 'Hazmat Abatement',
    costPerSquareFt: 12,
    description: 'Remove lead-based paint'
  },
  {
    name: 'Mold Remediation',
    category: 'Hazmat Abatement',
    costPerSquareFt: 18,
    description: 'Mold removal and treatment'
  }
];

// GREEN BUILDING / LEED MATERIALS
export const greenBuildingDatabase = [
  // === RECYCLED MATERIALS ===
  {
    name: 'Recycled Concrete Aggregate',
    category: 'Recycled Materials',
    tonsPerCubicYard: 1.4,
    costPerTon: 25,
    recycledContent: 100,
    carbonSavings: 0.05, // tons CO2 per ton material
    description: 'Crushed recycled concrete for base'
  },
  {
    name: 'Recycled Asphalt Pavement',
    category: 'Recycled Materials',
    tonsPerCubicYard: 1.85,
    costPerTon: 35,
    recycledContent: 100,
    carbonSavings: 0.08,
    description: 'Reclaimed asphalt for paving'
  },
  {
    name: 'Fly Ash Concrete (25%)',
    category: 'Recycled Materials',
    costPerCubicYard: 130,
    recycledContent: 25,
    carbonSavings: 0.15,
    description: 'Concrete with fly ash replacement'
  },
  {
    name: 'Slag Cement Concrete (50%)',
    category: 'Recycled Materials',
    costPerCubicYard: 135,
    recycledContent: 50,
    carbonSavings: 0.25,
    description: 'Concrete with slag cement'
  },
  {
    name: 'Recycled Steel (Rebar)',
    category: 'Recycled Materials',
    costPerTon: 950,
    recycledContent: 90,
    carbonSavings: 0.85,
    description: 'Rebar from recycled steel'
  },
  // === LOW IMPACT MATERIALS ===
  {
    name: 'FSC Certified Lumber',
    category: 'Sustainable Materials',
    costPremium: 15, // percent premium
    carbonSequestration: 0.9, // tons CO2 per ton wood
    description: 'Forest Stewardship Council certified wood'
  },
  {
    name: 'Bamboo Flooring',
    category: 'Sustainable Materials',
    costPerSquareFt: 6.50,
    carbonSequestration: 1.2,
    description: 'Rapidly renewable bamboo flooring'
  },
  {
    name: 'Cork Flooring',
    category: 'Sustainable Materials',
    costPerSquareFt: 8.50,
    carbonSequestration: 0.4,
    description: 'Sustainable cork flooring'
  },
  {
    name: 'Recycled Rubber Surfacing',
    category: 'Sustainable Materials',
    costPerSquareFt: 12,
    recycledContent: 95,
    description: 'Recycled tire rubber surfaces'
  },
  // === ENERGY EFFICIENCY ===
  {
    name: 'Cool Roof Coating',
    category: 'Energy Efficiency',
    costPerSquareFt: 2.50,
    solarReflectanceIndex: 78,
    description: 'Reflective roof coating'
  },
  {
    name: 'Green Roof System',
    category: 'Energy Efficiency',
    costPerSquareFt: 25,
    insulationValue: 4.5,
    description: 'Vegetated roof insulation'
  },
  {
    name: 'High-Albedo Paving',
    category: 'Energy Efficiency',
    costPerSquareFt: 8,
    solarReflectanceIndex: 29,
    description: 'Light colored pavement'
  },
  // === CARBON TRACKING ===
  {
    name: 'Portland Cement',
    category: 'Carbon Footprint',
    carbonPerTon: 0.93,
    description: 'Standard Portland cement CO2'
  },
  {
    name: 'Structural Steel',
    category: 'Carbon Footprint',
    carbonPerTon: 1.85,
    description: 'Virgin structural steel CO2'
  },
  {
    name: 'Hot Mix Asphalt',
    category: 'Carbon Footprint',
    carbonPerTon: 0.05,
    description: 'HMA production CO2'
  },
  {
    name: 'Aluminum',
    category: 'Carbon Footprint',
    carbonPerTon: 11.5,
    description: 'Virgin aluminum CO2'
  },
  {
    name: 'Plastic (HDPE)',
    category: 'Carbon Footprint',
    carbonPerTon: 1.8,
    description: 'HDPE production CO2'
  }
];

// PROJECT TYPES FOR SELECTION
export const projectTypes = [
  {
    id: 'commercial',
    name: 'Commercial Building',
    icon: 'Building2',
    description: 'Office buildings, retail, restaurants',
    relevantTabs: ['demo', 'import', 'trucking', 'tools', 'estimate']
  },
  {
    id: 'residential',
    name: 'Residential',
    icon: 'Home',
    description: 'Single family, multi-family, subdivisions',
    relevantTabs: ['demo', 'import', 'sitework', 'civil', 'trucking', 'tools', 'estimate']
  },
  {
    id: 'civil',
    name: 'Civil / Infrastructure',
    icon: 'Construction',
    description: 'Roads, bridges, utilities, drainage',
    relevantTabs: ['sitework', 'civil', 'environmental', 'trucking', 'tools', 'estimate']
  },
  {
    id: 'environmental',
    name: 'Environmental / Remediation',
    icon: 'Leaf',
    description: 'Site remediation, cleanup, restoration',
    relevantTabs: ['sitework', 'environmental', 'trucking', 'tools', 'estimate']
  },
  {
    id: 'industrial',
    name: 'Industrial / Oil Field',
    icon: 'Factory',
    description: 'Industrial facilities, oil & gas',
    relevantTabs: ['demo', 'import', 'excavation', 'trucking', 'tools', 'estimate']
  },
  {
    id: 'highway',
    name: 'Heavy Highway',
    icon: 'Route',
    description: 'Major roadways, highways, interchanges',
    relevantTabs: ['sitework', 'civil', 'environmental', 'trucking', 'tools', 'estimate']
  },
  {
    id: 'all',
    name: 'Full Access',
    icon: 'LayoutGrid',
    description: 'Access all calculators and features',
    relevantTabs: ['all']
  }
];
